export const mainMenu = [
  {
    name: "Home",
    route: "/",
  },
  {
    name: "About Me",
    route: "/about-me",
  },
  {
    name: "Blogs",
    route: "/blogs",
    subMenu: [
      {
        name: "Health & Wellness",
        route: "",
      },
      {
        name: "Travel",
        route: "",
      },
      {
        name: "Culture",
        route: "",
      },
    ],
  },
  {
    name: "Contact Me",
    route: "/contact-me",
  },
]
